module.exports = __webpack_public_path__ + "media/images/village/bg-gradient-dark-c7d9ba0aad88a2ae90f6e947dc4a3218.jpg";